module.exports = __webpack_public_path__ + "static/media/folha-modelo-redacao.bcdf67c7.pdf";